export default __webpack_public_path__ + "static/media/mulher.3397f811.svg";